import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Seccion from "../../Seccion";

function GastosGeneralCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_GENERAL = process.env.REACT_APP_URL_GASTOS_GENERAL;
  // const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_SUB_CATEGORIAS = process.env.REACT_APP_URL_SUB_CATEGORIAS;
  const URL_SOLICITANTES = process.env.REACT_APP_URL_SOLICITANTES;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState(hoy);
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");
  // const [conceptosGastos, setConceptosGastos] = useState([]);
  // const [selectedConcepto, setSelectedConcepto] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [subCategorias, setSubCategorias] = useState([]);
  const [selectedSubCategoria, setSelectedSubCategoria] = useState("");
  const [solicitantes, setSolicitantes] = useState([]);
  const [selectedSolicitante, setSelectedSolicitante] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    // axios
    //   .get(URL_CONCEPTOS_GASTOS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allConceptosGastos = res.data;
    //     setConceptosGastos(allConceptosGastos);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

      axios
        .get(URL_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allCategorias = res.data;
          setCategorias(allCategorias);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_SUB_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSubCategorias = res.data;
          setSubCategorias(allSubCategorias);
        })
        .catch((err) => {
          console.log(err);
        });
        
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
      axios
      .get(URL_SOLICITANTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSolicitantes = res.data;
        setSolicitantes(allSolicitantes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    }, []);

    function jalaBanco(e) {
      setSelectedBanco(e);
      bancos.map((a) => {
        if (a._id == e) {
          return setMoneda(a.moneda);
        }
      });
    }

  const calcula = (e) => {
    setSubtotal(e);
    setTotal(parseFloat(e) + parseFloat(iva));
  };

  const calculaIVA = (e) => {
    setIva(e);
    setTotal(parseFloat(subtotal) + parseFloat(e));
  };

  const saveGasto = (event) => {
    event.preventDefault();
    setValidaBoton(false);
        axios.post(
          URL_GASTOS_GENERAL,
          {
            is_active:"Si",
            fecha,
            subtotal,
            iva,
            total,
            descripcion,
            areas: AREAS_GENERAL,
            // conceptosGastos:selectedConcepto,
            categorias: selectedCategoria,
            subCategorias: selectedSubCategoria,
            solicitantes: selectedSolicitante,
            bancos: selectedBanco,
            empresas: selectedEmpresa,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then((data) => {

        axios
        .post(
        `${URL_MOVIMIENTOS_BANCOS}`,
        {
            fecha,
            importe: -total,
            tipo:"Egreso",
            bancos: selectedBanco,
            gastosGeneral:data.data._id,
            moneda,
            tipoCambio:1
        },
        {
            headers: {
            Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
            )}`,
            },
        }
        )

        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Gasto",
            detalle: `Fecha: ${fecha} / Solicitante: ${selectedSolicitante} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Listo", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "No se pudo completar",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.gastos_create ? (
        <div className="container">
          <div className="card container col-sm-8">
            <div className="page-header"><div><h3 className="page-title">Nuevo Gasto</h3></div></div>
            <Form onSubmit={saveGasto}>
              <Seccion titulo="Datos del gasto" icono="fas fa-receipt">
<Row>
<Col md={6}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Fecha
                    </Label>
                    <Input
                      type="date"
                      placeholder="Fecha"
                      value={fecha}
                      required
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col>
<Col md={6}>
              <Label>Empresa</Label>
                <Input
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Empresa</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
<Col md={6}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
<Col md={6}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Descripcion
                    </Label>
                    <Input
                      type="text"
                      placeholder="Descripcion"
                      value={descripcion}
                      required
                      onChange={(e) => {
                        setDescripcion(e.target.value);
                      }}
                    />
                  </Col>
</Row>
</Seccion>
<Seccion titulo="Clasificación" icono="fas fa-tags">
<Row>
<Col md={6}>
                    <Label className="mr-sm-2">Categoria</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedCategoria}
                        onChange={(e) => setSelectedCategoria(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {categorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>
<Col md={6}>
                    <Label className="mr-sm-2">SubCategoria</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSubCategoria}
                        onChange={(e) => setSelectedSubCategoria(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {subCategorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            if(a.categorias[0]._id == selectedCategoria)
                              return <option value={a._id}>{a.name}</option>
                          })}
                      </Input>
                      </Col>
<Col md={6}>
                    <Label className="mr-sm-2">Solicito / Autorizo</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSolicitante}
                        onChange={(e) => setSelectedSolicitante(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {solicitantes
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>
</Row>
</Seccion>
<Seccion titulo="Importes" icono="fas fa-coins">
<Row>
<Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Subtotal
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Subtotal"
                      value={subtotal}
                      required
                      onChange={(e) => calcula(e.target.value)}
                    />
                  </Col>
<Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      IVA
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="IVA"
                      value={iva}
                      required
                      onChange={(e) => calculaIVA(e.target.value)}
                    />
                  </Col>
<Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Total
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder={total}
                      disabled
                    />
                  </Col>
</Row>
</Seccion>
<div className="form-acciones">
<Button
                    href="/Gastos"
                    className="btn btn-secondary"
                  >
                    Regresar
                  </Button>
{validaBoton ? (
                    <Button type="submit" className="btn btn-primary">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-primary" disabled>
                      Guardar
                    </Button>
                  )}
</div>
<div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>

            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default GastosGeneralCreate;
